import { render, staticRenderFns } from "./pbl4.vue?vue&type=template&id=3519d2c2&scoped=true&"
import script from "./pbl4.vue?vue&type=script&lang=js&"
export * from "./pbl4.vue?vue&type=script&lang=js&"
import style0 from "./pbl4.vue?vue&type=style&index=0&id=3519d2c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3519d2c2",
  null
  
)

export default component.exports